import { defineMessages } from 'react-intl-next';

export const messages: {
	AdminEmptyStateMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	UserEmptyStateMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	EmptyStateHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	infoButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	AdminEmptyStateMessage: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.empty-state.admin-empty-state-message',
		defaultMessage:
			'Add manager information in your identity provider, and show a tree of manager and direct reports on profiles',
		description: 'Message when admin has not connected IdP, for admin',
	},
	UserEmptyStateMessage: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.empty-state.user-empty-state-message',
		defaultMessage:
			'Ask your admin to connect manager information to Atlassian, and see manager and direct reports on profiles',
		description: 'Message when admin has not connected IdP, for user',
	},
	EmptyStateHeading: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.empty-state.heading',
		defaultMessage: 'See manager and direct reports',
		description: 'Heading text displayed in empty state when no reporting line data is available',
	},
	infoButton: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.empty-state.info-button',
		defaultMessage: 'Learn more',
		description: 'External info link to article on how to sync the manager attribute',
	},
});
